import { ReceptionVm } from './reception.vm';

export class GetReceptionVm extends ReceptionVm {}
